var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPorterAlert1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F0483E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0483E",
    d: "M10.25 7.333h3.5v9.333h-3.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m18.686 14.729-4.78-8.059c-.859-1.449-2.953-1.449-3.815 0L5.314 14.73c-.878 1.477.189 3.347 1.906 3.347h9.56c1.717 0 2.784-1.87 1.906-3.347zM12 16.293a1.026 1.026 0 1 1 0-2.052 1.026 1.026 0 0 1 0 2.052zm1.053-6.527-.126 2.964a.926.926 0 0 1-1.851 0l-.126-2.964a1.055 1.055 0 0 1 2.106-.11c0 .039 0 .074-.003.11z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPorterAlert1);
export default __webpack_public_path__ + "static/media/porter_alert1.3692bacb45bbfcb7a85e0b9e37bd7e02.svg";
export { ForwardRef as ReactComponent };